import { useEffect } from "react";

import InContactLogo from "../../../Assets/images/InContactLogo";
import { User } from "../../../Models/User";
import UserContextValueProvider from "../../Providers/Value/UserContextValueProvider";
import { AuthenticationLogoCard } from "../Components/AuthenticationCard";
import SsoForm from "../Components/AuthenticationForms/SsoForm";
import { ILoginStepProps } from "../Components/LoginProcess";
import usePutUserIvrId from "../Hooks/UsePutUserIvrId";
import IAuthorizationStepProps from "../Types/IAuthorizationStepProps";

interface IIvrAuthenticationLoginStepProps extends IAuthorizationStepProps<string> {
  user: User;
}

const IvrAuthenticationLoginStep: React.FC<IIvrAuthenticationLoginStepProps & ILoginStepProps> = ({
  isIdentityReady,
  user,
  onComplete,
  setAuthorization
}) => {
  const { isLoading, errorMessage, userIvrId, execute } = usePutUserIvrId({ user });

  useEffect(() => {
    if (userIvrId) setAuthorization(userIvrId);
  }, [userIvrId]);

  useEffect(() => {
    if (isIdentityReady) onComplete();
  }, [isIdentityReady]);

  return AuthenticationLogoCard({
    footer: undefined,
    logo: InContactLogo({}),
    salutation: isLoading
      ? "Please authenticate with NICE InContact on the opened tab."
      : "Please link your InContact account to your GEM account.",
    children: [SsoForm({ onClick: execute, isLoading: isLoading, label: "Link", errorMessage })]
  });
};

const UserContextIvrAuthenticationLoginStep: React.FC<ILoginStepProps> = UserContextValueProvider<
  IIvrAuthenticationLoginStepProps,
  IIvrAuthenticationLoginStepProps & ILoginStepProps
>({
  Component: IvrAuthenticationLoginStep,
  map: ({ user, setUser }) => ({
    isIdentityReady: Boolean(user.externalIds.ivr),
    user,
    setAuthorization: ivrId => setUser(u => ({ ...u, externalIds: { ...u.externalIds, ivr: ivrId } }))
  })
});

export default UserContextIvrAuthenticationLoginStep;
